import { useCallback, useContext, useEffect, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddBadge = () => {
  const { t } = useLocale();
  const { save } = useService("Data", "badge");
  const { setTitle } = useService("Meta");
  const { generateUID, showAlert } = useService("Misc");
  const { navigateTo } = useContext(NavigatorContext);
  const [title, settitle] = useState<string>("");
  const [image, setimage] = useState<string>("[]");

  useEffect(() => {
    setTitle(t("addBadge"), "admin");
  }, [setTitle, t]);

  const addBadge = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        badgeObject = {
          title,
          image,
          uid: generateUID(),
        };
      if (image === "[]") {
        errorMsg = t("errorMsg.required.badgeImage");
        error = true;
      }
      if (title === "") {
        errorMsg = t("errorMsg.required.badgeTitle");
        error = true;
      }
      if (!error) {
        const result = await save(badgeObject);
        if (result.status) {
          showAlert({ type: "success", msg: t("success.addBadge") });
          navigateTo({ route: "/admin/badge/list" });
        } else {
          showAlert({ type: "error", msg: t("errorMsg.fail.addBadge") });
        }
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [generateUID, image, navigateTo, save, showAlert, t, title]
  );

  const setBadgeTitle = (e) => settitle(e.target.value);
  return {
    setBadgeTitle,
    title,
    image,
    setimage,
    addBadge,
  };
};
